import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export function FacebookIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M56.8745 28.0169C56.8745 12.5516 44.1347 0 28.4373 0C12.7399 0 0
        12.5516 0 28.0169C0 41.577 9.78242 52.8678 22.7498
        55.4734V36.4219H17.0624V28.0169H22.7498V21.0126C22.7498 15.6054
        27.2145 11.2067 32.7029 11.2067H39.8122V19.6118H34.1247C32.5607
        19.6118 31.281 20.8726 31.281
        22.4135V28.0169H39.8122V36.4219H31.281V55.8936C45.6418 54.4928
        56.8745 42.5576 56.8745 28.0169Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LinkedInIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 61 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.3985 0C13.6096 0 0 13.8291 0 30.8886C0 47.9481 13.6096
        61.7772 30.3985 61.7772C47.1873 61.7772 60.7969 47.9481 60.7969
        30.8886C60.7969 13.8291 47.1873 0 30.3985
        0ZM22.9572 43.6913H16.8015V23.5622H22.9572V43.6913ZM19.8413
        21.0911C17.8971 21.0911 16.64 19.6915 16.64 17.9604C16.64 16.194
        17.9351 14.8362 19.9205 14.8362C21.9059 14.8362 23.1218 16.194
        23.1598 17.9604C23.1598 19.6915 21.9059 21.0911 19.8413
        21.0911ZM45.4394 43.6913H39.2837V32.536C39.2837 29.9394 38.3907
        28.1762 36.1647 28.1762C34.4643 28.1762 33.4541 29.3699 33.0077
        30.5186C32.843 30.9272 32.8018 31.5064 32.8018
        32.0823V43.688H26.643V29.9812C26.643 27.4683 26.5638 25.3673
        26.4815 23.559H31.8297L32.1115 26.355H32.235C33.0457 25.0423
        35.0311 23.1053 38.3527 23.1053C42.4027 23.1053 45.4394 25.8628
        45.4394 31.7895V43.6913Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function InstagramIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.3607 0C34.5597 0.00853093 36.1834 0.0255928 37.5853
        0.0654038L38.1369 0.0853092C38.7739 0.108058 39.4023 0.136495
        40.1616 0.170618C43.1871 0.3128 45.2516 0.790533 47.0629
        1.49291C48.9397 2.2152 50.5207 3.19341 52.1018 4.77163C53.5483
        6.19269 54.6672 7.91236 55.3804 9.81057C56.0828 11.622 56.5605
        13.6865 56.7027 16.7149C56.7368 17.4713 56.7652 18.0998 56.788
        18.7396L56.805 19.2913C56.8477 20.6903 56.8648 22.3141 56.8705
        25.5132L56.8733 27.6345V31.3597C56.8802 33.4339 56.8584 35.508
        56.8079 37.5816L56.7908 38.1332C56.7681 38.7731 56.7397 39.4015
        56.7055 40.1579C56.5633 43.1864 56.0799 45.248 55.3804
        47.0623C54.6672 48.9605 53.5483 50.6802 52.1018 52.1012C50.6807
        53.5478 48.9611 54.6667 47.0629 55.3799C45.2516 56.0823 43.1871
        56.5601 40.1616 56.7022L38.1369 56.7875L37.5853 56.8046C36.1834
        56.8444 34.5597 56.8643 31.3607 56.87L29.2393
        56.8728H25.5171C23.442 56.8802 21.367 56.8584 19.2925
        56.8074L18.7408 56.7904C18.0658 56.7648 17.3909 56.7354 16.7162
        56.7022C13.6906 56.5601 11.6262 56.0823 9.81198 55.3799C7.91483
        54.6663 6.1962 53.5474 4.77599 52.1012C3.32845 50.6804 2.20855
        48.9608 1.4945 47.0623C0.792134 45.2509 0.314411 43.1864 0.172232
        40.1579L0.0869249 38.1332L0.0727073 37.5816C0.0202888 35.508
        -0.0034103 33.4339 0.00161742 31.3597V25.5132C-0.00625332
        23.439 0.0146018 21.3648 0.0641765 19.2913L0.0840815
        18.7396C0.10683 18.0998 0.135266 17.4713 0.169389
        16.7149C0.311568 13.6865 0.78929 11.6248 1.49166
        9.81057C2.20737 7.91158 3.32925 6.19185 4.77884
        4.77163C6.19822 3.32578 7.91585 2.20688 9.81198
        1.49291C11.6262 0.790533 13.6878 0.3128 16.7162
        0.170618C17.4726 0.136495 18.1039 0.108058 18.7408
        0.0853092L19.2925 0.0682472C21.366 0.0177236 23.4401
        -0.00407977 25.5143 0.00284344L31.3607
        0ZM28.4375 14.2182C24.6666 14.2182 21.0502 15.7162 18.3839
        18.3826C15.7175 21.0491 14.2195 24.6655 14.2195
        28.4364C14.2195 32.2073 15.7175 35.8238 18.3839
        38.4902C21.0502 41.1567 24.6666 42.6546 28.4375
        42.6546C32.2083 42.6546 35.8247 41.1567 38.491
        38.4902C41.1574 35.8238 42.6554 32.2073 42.6554
        28.4364C42.6554 24.6655 41.1574 21.0491 38.491
        18.3826C35.8247 15.7162 32.2083 14.2182 28.4375
        14.2182ZM28.4375 19.9055C29.5577 19.9053 30.6671 20.1258
        31.7021 20.5543C32.7372 20.9829 33.6777 21.6111 34.47
        22.4031C35.2623 23.1952 35.8908 24.1355 36.3197
        25.1705C36.7486 26.2054 36.9694 27.3147 36.9696
        28.435C36.9698 29.5553 36.7493 30.6647 36.3208
        31.6998C35.8923 32.7348 35.2641 33.6754 34.472
        34.4677C33.68 35.26 32.7397 35.8885 31.7048
        36.3174C30.6698 36.7463 29.5606 36.9672 28.4403
        36.9674C26.1778 36.9674 24.008 36.0686 22.4081
        34.4687C20.8083 32.8688 19.9096 30.699 19.9096
        28.4364C19.9096 26.1739 20.8083 24.004 22.4081
        22.4041C24.008 20.8043 26.1778 19.9055 28.4403
        19.9055M43.3691 9.95275C42.4264 9.95275 41.5223 10.3272
        40.8557 10.9939C40.1891 11.6605 39.8146 12.5646 39.8146
        13.5073C39.8146 14.45 40.1891 15.3541 40.8557
        16.0208C41.5223 16.6874 42.4264 17.0619 43.3691
        17.0619C44.3118 17.0619 45.2159 16.6874 45.8825
        16.0208C46.5491 15.3541 46.9236 14.45 46.9236
        13.5073C46.9236 12.5646 46.5491 11.6605 45.8825
        10.9939C45.2159 10.3272 44.3118 9.95275 43.3691 9.95275Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PhoneIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 -1 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.7659 2.89822C16.297 0.885178 14.2632 -0.0219637 12.1061
        0.000403363C10.0594 0.0202852 8.06664 0.867772 6.40258
        1.99607C4.70529 3.1525 3.25803 4.61901 2.14228 6.31296C1.0894
        7.92588 0.329276 9.83212 0.431996 11.6936C0.927618 20.6478
        6.13294 30.2163 13.444 37.2967C20.75 44.3697 30.5058 49.2856
        40.3566 48.3462C42.2877 48.1623 44.1136 47.2104 45.6056
        45.9976C47.1487 44.7326 48.4096 43.1767 49.3112 41.4247C50.1843
        39.7049 50.7056 37.7217 50.418 35.7906C50.1201 33.7776 48.9568
        31.9782 46.8176 30.7853C46.3745 30.5365 45.9361 30.2796 45.5028
        30.0149C45.1176 29.7838 44.7068 29.5328 44.2086
        29.2445C43.191 28.6373 42.1172 28.1231 41.0011
        27.7086C39.8533 27.3035 38.541 27.0376 37.1748
        27.219C35.7599 27.4079 34.4451 28.054 33.3074
        29.2122C32.4318 30.1068 31.1426 30.3852 29.3296
        29.8782C27.4858 29.3613 25.4108 28.0789 23.6081
        26.3442C21.8054 24.6144 20.4418 22.5914 19.8589
        20.7648C19.2836 18.9555 19.5379 17.6259 20.4367
        16.7088C21.6513 15.4712 22.2984 14.0943 22.4345
        12.638C22.5681 11.2214 22.2034 9.88924 21.6821
        8.72615C20.9015 6.98898 19.5764 5.26168 18.5389
        3.91469C18.2781 3.57792 18.0212 3.23824 17.7685 2.89573"
        fill="currentColor"
      />
    </svg>
  );
}

export function EnvelopeIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 93 51 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.08751 99.8676L25.3724 111.602L49.6571 99.8676C49.5672
        98.3719 48.889 96.9661 47.7616 95.938C46.6341 94.9099 45.1427
        94.3373 43.5927 94.3376H7.15187C5.60187 94.3373 4.11042 94.9099
        2.98298 95.938C1.85553 96.9661 1.17741 98.3719 1.08751 99.8676Z"
        fill="currentColor"
      />
      <path
        d="M49.6571 106.109L25.3724 118.057L1.08751
        106.109V123.678C1.08751 125.263 1.72715 126.782 2.86572
        127.902C4.00429 129.023 5.54852 129.652 7.1587
        129.652H43.5859C45.196 129.652 46.7403 129.023 47.8788
        127.902C49.0174 126.782 49.6571 125.263
        49.6571 123.678V106.109Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WhatsAppIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.4373 0C44.1432 0 56.8746 12.7313 56.8746 28.4371C56.8746 44.1429
        44.1432 56.8742 28.4373 56.8742C23.4117 56.8828 18.4745 55.5529 14.1334
        53.021L0.0114189 56.8742L3.85614 42.7466C1.32226 38.4041-0.0087633
        33.4648 4.34199e-05 28.4371C4.34199e-05 12.7313 12.7314 0 28.4373
        0ZM18.7459 15.0717L18.1771 15.0944C17.8094 15.1197 17.4501 15.2163
        17.1193 15.3788C16.8109 15.5537 16.5294 15.7721 16.2832
        16.0271C15.942 16.3485 15.7486 16.6272 15.541
        16.8973C14.4892 18.2649 13.9228 19.9438 13.9315
        21.6691C13.9371 23.0625 14.3011 24.4189 14.8699
        25.6872C16.033 28.2523 17.9468 30.968 20.472
        33.4847C21.0806 34.0904 21.6778 34.6989 22.3204
        35.2648C25.4583 38.0272 29.1974 40.0194 33.2403
        41.0831L34.8556 41.3305C35.3817 41.3589 35.9078 41.3191 36.4367
        41.2935C37.2648 41.2498 38.0732 41.0256 38.8055
        40.6366C39.1776 40.4442 39.541 40.2355 39.8947
        40.011C39.8947 40.011 40.0151 39.9295 40.2501
        39.7551C40.634 39.4707 40.8701 39.2688 41.1886
        38.9361C41.4274 38.6896 41.6265 38.4033 41.7857
        38.0773C42.0076 37.6137 42.2294 36.7293 42.3204
        35.9928C42.3886 35.4298 42.3687 35.1227 42.3602
        34.9321C42.3488 34.6278 42.0957 34.3122 41.8199
        34.1785L40.1648 33.4363C40.1648 33.4363 37.6908 32.3586 36.1779
        31.6704C36.0196 31.6014 35.85 31.5619 35.6774
        31.5538C35.4828 31.5334 35.2861 31.5552 35.1007
        31.6175C34.9152 31.6798 34.7453 31.7812 34.6025
        31.9149C34.5883 31.9093 34.3977 32.0714 32.3417
        34.5624C32.2237 34.721 32.0612 34.8409 31.8748
        34.9067C31.6884 34.9725 31.4867 34.9814 31.2952
        34.9321C31.1099 34.8827 30.9284 34.82 30.7521
        34.7444C30.3995 34.5966 30.2772 34.5397 30.0355
        34.4373C28.4028 33.7261 26.8916 32.7637 25.5566
        31.5851C25.1983 31.2723 24.8656 30.931 24.5243
        30.6012C23.4056 29.5297 22.4306 28.3176 21.6237
        26.9953L21.4559 26.7252C21.3373 26.5426 21.2399 26.347 21.1659
        26.1422C21.0578 25.7242 21.3394 25.3886 21.3394
        25.3886C21.3394 25.3886 22.0304 24.6322 22.3517
        24.2227C22.6645 23.8246 22.929 23.4379 23.0996
        23.162C23.4352 22.6217 23.5404 22.0672 23.3641
        21.6378C22.5679 19.6927 21.7451 17.758 20.8957
        15.8338C20.728 15.4527 20.2303 15.1797 19.7782
        15.1257C19.6246 15.1067 19.471 15.0916 19.3175
        15.0802C18.9356 15.0583 18.5528 15.0621 18.1714
        15.0916L18.7459 15.0717Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MapPinIcon(props: IconProps) {
  return (
    <svg
      viewBox="-1 171 50 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.8809 172.064C30.2145 172.064 36.2885 174.56 40.7671
        179.001C45.2456 183.443 47.7616 189.467 47.7616
        195.748C47.7616 203.838 43.3145 210.459 38.6285
        215.208C36.2873 217.556 33.7327 219.684 30.9973
        221.566L29.8669 222.33L29.3362 222.68L28.3359
        223.311L27.4443 223.851L26.3405 224.488C25.5913
        224.912 24.7436 225.135 23.8809 225.135C23.0182
        225.135 22.1704 224.912 21.4212 224.488L20.3173
        223.851L18.9376 223.009L18.4281 222.68L17.3402
        221.961C14.3891 219.981 11.6403 217.719 9.13308
        215.208C4.44713 210.456 0 203.838 0
        195.748C0 189.467 2.516 183.443 6.99452
        179.001C11.473 174.56 17.5473 172.064 23.8809
        172.064ZM23.8809 187.854C22.8356 187.854 21.8004
        188.058 20.8346 188.455C19.8689 188.851 18.9913
        189.433 18.2521 190.166C17.5129 190.899 16.9266
        191.769 16.5266 192.727C16.1265 193.685 15.9206
        194.712 15.9206 195.748C15.9206 196.785 16.1265
        197.812 16.5266 198.769C16.9266 199.727 17.5129
        200.597 18.2521 201.331C18.9913 202.064 19.8689
        202.645 20.8346 203.042C21.8004 203.439 22.8356
        203.643 23.8809 203.643C25.9921 203.643 28.0167
        202.811 29.5095 201.331C31.0024 199.85 31.8411
        197.842 31.8411 195.748C31.8411 193.654 31.0024
        191.646 29.5095 190.166C28.0167 188.685 25.9921
        187.854 23.8809 187.854Z"
        fill="currentColor"
      />
    </svg>
  );
}
